import React from 'react';
import { Plus } from 'lucide-react';
import MemberNameLink from '../../common/MemberNameLink';

function PeopleTagged({ people = [], onTagMore, variant = 'default' }) {
  const title = variant === 'media-only'
    ? "Who's in these photos?"
    : "In this Story";

  return (
    <div className="sidebar-card people-tagged">
      <h3 className="sidebar-title">
        <span>👥</span> {title}
      </h3>

      <div className="tagged-list">
        {people.map((person) => (
          <div key={person.id} className="tagged-person">
            <div className="person-avatar">
              <span>{person.emoji}</span>
            </div>
            <span className="person-name"><MemberNameLink memberId={person.id} name={person.name} /></span>
          </div>
        ))}

        <button className="tag-more-btn" onClick={onTagMore}>
          <Plus size={14} />
          {variant === 'media-only' ? 'Tag more' : 'Tag'}
        </button>
      </div>
    </div>
  );
}

export default PeopleTagged;
